<template>
  <div>
    <div v-if="socketId === client.socketId" style="color:#4CAF50; font-size: 12px;">本機</div>
    <div style="font-size: 16px;">{{client.email}} ({{client.name}})</div>
    <div>連線 ID: {{client.socketId}}</div>
    <div>
      瀏覽器：{{userAgent.family}} {{userAgent.major}}.{{userAgent.minor}}.{{userAgent.patch}}
    </div>
    <div>裝置：{{userAgent.device.family}}</div>
    <div>
      作業系統：
      {{userAgent.os.family}} {{userAgent.os.major}}.{{userAgent.os.minor}}.{{userAgent.os.patch}}
    </div>
    <div>來源 IP 位置：{{client.address}}</div>
  </div>
</template>

<script>
import useragent from 'useragent'

export default {
  name: 'ClientInformation',
  computed: {
    userAgent () {
      return useragent.parse(this.client.userAgent)
    }
  },
  props: {
    socketId: String,
    client: Object
  }
}
</script>
